export default __webpack_public_path__ + "static/media/logo-us-nike.4e6700f4.svg";